import { PortfolioOverviewScreen } from "@civala/investor-nexus-pitch"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/investments")({
  component: PortfolioOverviewScreen,
})
